import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { Quotation, QuotationFilters } from '../../lib/types/models/quotation/quotation'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getQuotations(req: PaginationRequest<QuotationFilters>) {
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(constructApiUrl(API.quotation.getAll.url, null), req)
    )
    .get<PaginationResponse<Quotation>>()
}
